import { render, staticRenderFns } from "./OrderObjectsTab.vue?vue&type=template&id=12b6b7f2&scoped=true"
import script from "./OrderObjectsTab.vue?vue&type=script&lang=js"
export * from "./OrderObjectsTab.vue?vue&type=script&lang=js"
import style0 from "./OrderObjectsTab.vue?vue&type=style&index=0&id=12b6b7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b6b7f2",
  null
  
)

export default component.exports